import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { getShipment } from '../shipments.endpoints';
import { Shipment } from '../../../Models';

export type GetShipment = UseQueryResult<Shipment | undefined> & {
    shipment: Shipment | undefined;
};
export const useGetShipment = (shipmentId: string | undefined): GetShipment => {
    const hook = useQuery<Shipment | undefined>({
        queryKey: ['getGetShipment', shipmentId || ''],
        queryFn: () => (shipmentId ? getShipment(shipmentId) : undefined),
        initialData: undefined,
        retry: false,
        staleTime: Infinity,
        cacheTime: Infinity,
    });

    return { ...hook, shipment: hook.data };
};
